import * as React from "react";
const Dashboard = (props: any) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1.2 14.392h2.4v8.4a1.2 1.2 0 0 0 1.2 1.2h14.4c.664 0 1.2-.537 1.2-1.2v-8.4h2.4a1.199 1.199 0 0 0 .892-2.003l-10.8-12c-.455-.507-1.329-.507-1.784 0l-10.8 12a1.2 1.2 0 0 0 .892 2.003m7.139-.38c.037.114.975 2.78 3.661 2.78 2.723 0 3.65-2.745 3.66-2.774l2.28.745c-.059.182-1.496 4.429-5.94 4.429s-5.881-4.247-5.94-4.427z"
            fill="currentColor"
        />
    </svg>
);
export default Dashboard;
